import { Globe, Clock } from "lucide-react";
import interestMembershipBanner from "@/assets/interest-membership-banner.webp";

const InterestFree = () => {
  return (
    <section className="flex flex-col md:flex-row">
      {/* Left - Interest Free Plans */}
      <div className="md:w-1/2 relative min-h-[500px]">
        {/* Background image (bottom portion with AC unit + card) */}
        <div
          className="absolute inset-0 bg-cover bg-left-bottom"
          style={{
            backgroundImage: `url(${interestMembershipBanner})`,
            backgroundPosition: "left bottom",
          }}
        />
        {/* Dark overlay for text area */}
        <div className="absolute inset-0 bg-acg-dark/90" />

        <div className="relative z-10 flex flex-col justify-between h-full p-10 md:p-14">
          {/* Title */}
          <div>
            <div className="w-6 h-6 border-t-4 border-l-4 border-secondary mb-4" />
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary-foreground leading-tight">
              100% Interest<br />Free Plans
            </h2>
          </div>

          {/* Features row */}
          <div className="flex flex-wrap items-center gap-4 mt-8">
            <div className="flex items-center gap-2">
              <Globe className="w-8 h-8 text-secondary" />
              <div>
                <p className="font-bold text-primary-foreground text-sm">All Major Lenders</p>
                <p className="text-xs text-primary-foreground/70">The top lenders in Australia</p>
              </div>
            </div>

            <a
              href="/finance-options"
              className="bg-secondary text-primary-foreground font-bold px-6 py-3 rounded hover:opacity-90 transition-opacity uppercase text-xs tracking-wider"
            >
              View Payment Plan
            </a>

            <div className="flex items-center gap-2">
              <Clock className="w-8 h-8 text-secondary" />
              <div>
                <p className="font-bold text-primary-foreground text-sm">5 Minute Approvals!</p>
                <p className="text-xs text-primary-foreground/70">Our process is simple & fast</p>
              </div>
            </div>
          </div>

          {/* Payment partners */}
          <div className="mt-6">
            <p className="text-sm text-primary-foreground">
              <span className="font-bold">Have an account with any of our payment partners?</span>{" "}
              <span className="text-primary-foreground/70">Transitioning will be even easier!</span>
            </p>
            <div className="flex items-center gap-6 mt-3 text-primary-foreground font-bold text-lg">
              <span>zip</span>
              <span>humm<span className="text-xs align-super">90</span></span>
              <span>humm</span>
              <span>brighte</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right - ACG Membership */}
      <div className="md:w-1/2 relative min-h-[500px] bg-acg-charcoal overflow-hidden">
        <div className="absolute inset-0 bg-[hsl(215,30%,30%)]" />

        <div className="relative z-10 flex flex-col justify-between h-full p-10 md:p-14">
          {/* Title */}
          <div>
            <div className="w-6 h-6 border-t-4 border-l-4 border-primary mb-4" />
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary-foreground leading-tight">
              Our ACG<br />Membership
            </h2>
          </div>

          {/* Features row */}
          <div className="flex flex-wrap items-center gap-4 mt-8">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 text-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
              </div>
              <div>
                <p className="font-bold text-primary-foreground text-sm">Priority Servicing</p>
                <p className="text-xs text-primary-foreground/70">Applicable to all services</p>
              </div>
            </div>

            <a
              href="/membership"
              className="bg-primary text-primary-foreground font-bold px-6 py-3 rounded hover:opacity-90 transition-opacity uppercase text-xs tracking-wider"
            >
              View ACG Membership Benefits
            </a>

            <div className="flex items-center gap-2">
              <div className="w-8 h-8 text-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <div>
                <p className="font-bold text-primary-foreground text-sm">Exclusive Benefits</p>
                <p className="text-xs text-primary-foreground/70">Discount, 24/7 support & more!</p>
              </div>
            </div>
          </div>

          {/* Discount badges */}
          <div className="flex items-center gap-6 mt-8">
            <div className="w-32 h-32 rounded-full border-4 border-primary-foreground flex flex-col items-center justify-center">
              <span className="text-3xl font-black text-primary-foreground">25%</span>
              <span className="text-xs font-bold text-primary-foreground">OFF</span>
              <span className="text-[10px] text-primary-foreground text-center leading-tight mt-1">
                System Upgrades<br />(excluding promos)
              </span>
            </div>
            <div className="w-24 h-24 rounded-full border-4 border-primary-foreground flex flex-col items-center justify-center">
              <span className="text-2xl font-black text-primary-foreground">20%</span>
              <span className="text-[10px] font-bold text-primary-foreground">OFF</span>
              <span className="text-[9px] text-primary-foreground text-center leading-tight mt-1">
                Service &<br />Maintenance
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterestFree;
